import { FC } from "react";

import { Locales } from "@simplyk/common";

import { TranslationSection } from "../../sharedComponents/TranslationSection";

import { PrizeTexts, PrizeTranslationCard } from "./PrizeTranslationCard/PrizeTranslationCard";

import { useTranslate } from "@/common/hooks/useTranslate";
import { TranslationLine } from "@/components/TranslationLine/TranslationLine";

export interface PrizeToTranslate {
  id: string;
  value: number | null;
  source?: PrizeTexts;
  saved?: PrizeTexts;
}

interface PrizeTranslationSectionProps {
  prizes: PrizeToTranslate[];
  translationLocale: Locales;
  isTranslating: boolean;
  translatedPrizeIds: ReadonlySet<string>;
}

export const PrizeTranslationSection: FC<PrizeTranslationSectionProps> = ({
  prizes,
  translationLocale,
  isTranslating,
  translatedPrizeIds,
}) => {
  const { t } = useTranslate();

  if (prizes.length === 0) {
    return null;
  }

  return (
    <TranslationSection title={t("dashboard", "liveFormEditor.navigation.prizes")}>
      {prizes.map((prize, index) => (
        <TranslationLine key={prize.id}>
          <PrizeTranslationCard
            index={index}
            ticketingPrizeId={prize.id}
            value={prize.value}
            savedTexts={prize.source}
            translationLocale={translationLocale}
            isTranslationColumn={false}
          />
          <PrizeTranslationCard
            index={index}
            ticketingPrizeId={prize.id}
            value={prize.value}
            savedTexts={prize.saved}
            textsToTranslate={prize.source}
            translationLocale={translationLocale}
            isTranslationColumn
            isLoading={isTranslating && !translatedPrizeIds.has(prize.id)}
          />
        </TranslationLine>
      ))}
    </TranslationSection>
  );
};
